import styled from 'styled-components';

export const ConsentBlockContainer = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 20px 24px;
    border-radius: 12px;
    border: 1px solid ${(props) => props.theme.palette.secondaryA9};
    background: ${(props) => props.theme.palette.primaryA7};
    text-align: left;

    ${(props) => props.theme.breakpointTo.sm} {
        padding: 16px;
    }

    .consent-block {
        &__item {
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            gap: 12px;
        }

        &__text {
            width: 100%;
            white-space: pre-line;
        }

        &__text--full {
            max-height: 200px;
            overflow-y: auto;
            padding: 12px 14px;
            border-radius: 8px;
            border: 1px solid ${(props) => props.theme.palette.primaryA5};
            background: ${(props) => props.theme.palette.secondaryA12};
        }

        &__links {
            display: flex;
            flex-wrap: wrap;
            gap: 16px;
        }
    }
`;
